import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  country: null,
  agents: [],
  city: [],
  hotel: [],

  listCountry: [],
  transport: [],
  travelType: [],
  sectors: [],
  airports: [],
  passportDetails: null,
  dashboardData: [],
  modalParams: null,
  modalMapping: {
    "allow-htl-mecca": "AllowHotel",
    "allow-htl-medina": "AllowHotel",
    "allow-htl-jeddah": "AllowHotel",

    "allow-tpt-mecca": "AllowTPT",
    "allow-tpt-medina": "AllowTPT",
    "allow-tpt-jeddah": "AllowTPT",

    "jeddah-arrival": "Arrival",
    "medina-arrival": "Arrival",
    "mecca-arrival": "Arrival",
 
    "departure-medina": "Departure", 
    "departure-jeddah": "Departure",
    "departure-mecca": "Departure",

    "check-out-mecca": "Check_Out",
    "check-out-jeddah": "Check_Out",
    "check-out-medina": "Check_Out",

    "check-in-medina": "CheckIn",
    "check-in-jeddah": "CheckIn",
    "check-in-mecca": "CheckIn",
  },

  AllowHotel: [
    {
      title: "BRN no/Cash",
      state: "brn-no",
      key: "brn_select",
      type: "select",
    },
    {
      title: "Actual Hotel",
      state: "actual-Hotel",
      key: "actual_hotel",
      type: "select",
    },

    {
      title: "Package Hotel",
      state: "package-Hotel",
      key: "package_hotel",
      type: "select",
    },

    {
      title: "Accomodation",
      state: "accommodation",
      key: "accommodation",
      type: "select",
    },

    {
      title: "Origin",
      key: "origin",
      state: "origin",
      type: "select",
    },

    {
      title: "Room Number",
      state: "room-no",
      key: "input",
      type: "input/number",
    },

    {
      title: "Actual No Of Bed (Room)",
      state: "no-of-bed",
      key: "input",
      type: "input/number",
    },

    {
      title: "Actual No Of Bed (voucher)",
      state: "no-of-bed-voucher",
      key: "input",
      type: "input/number",
    },

    {
      title: "Check In Date",
      state: "in-date",
      key: "input",
      type: "input/date",
    },

    {
      title: "Actual Arrival Time",
      state: "actual-arrival-time",
      key: "input",
      type: "input/time",
    },

    {
      title: "Check Out Date",
      state: "out-date",
      key: "input",
      type: "input/date",
    },
  ],

  Arrival: [
    {
      title: "BRN no/Cash",
      state: "brn-no",
      key: "brn_select",
      type: "select",
    },

    {
      title: "Actual Hotel",
      key: "actual_hotel",
      state: "actual-Hotel",
      type: "select",
    },

    {
      title: "Hotel Time",
      key: "hotel_time",
      state: "hotel-Time",
      type: "input/time",
    },

    {
      title: "Seats",
      state: "no-of-seats",
      key: "input",
      type: "input/number",
    },

    {
      title: "Vehicle Number",
      state: "vehicle-number",
      key: "input",
      type: "input/number",
    },

    {
      title: "Driver Name",
      state: "driver-Name",

      key: "input",
      type: "input/text",
    },

    {
      title: "Driver Mobile Number",
      state: "driver-number",
      key: "input",
      type: "input/number",
    },

    {
      title: "Check Out Date",
      state: "out-date",

      key: "input",
      type: "input/date",
    },

    {
      title: "Check Out Time",
      state: "out-time",
      key: "input",
      type: "input/time",
    },

    {
      title: "Departure Time",
      state: "departure-time",
      key: "input",
      type: "input/time",
    },

    {
      title: "Transport Destination",
      state: "transport-destination",

      key: "input",
      type: "input/text",
    },
    {
      title: "Room No",
      state: "room-no",
      key: "input",
      type: "input/number",
    },
    {
      title: "Pickup Point",
      state: "pickup-point",
      key: "input",
      type: "input/text",
    },
  ],

  Departure: [
    {
      title: "BRN no/Cash",
      state: "brn-no",

      key: "brn_select",
      type: "select",
    },
    {
      title: "Transport Company",
      state: "transport-company",

      key: "tranport_companies",
      type: "select",
    },

    {
      title: "Actual Hotel",
      state: "actual-Hotel",

      key: "actual_hotel",
      type: "select",
    },

    {
      title: "Driver Name",
      state: "driver-name",

      key: "input",
      type: "input/text",
    },

    {
      title: "Driver #",
      state: "driver-number",
      key: "input",
      type: "input/number",
    },

    {
      title: "Vehicle #",
      state: "vehicle-number",
      key: "input",
      type: "input/number",
    },

    {
      title: "Actual No Of Seats",
      state: "no-of-seats",
      key: "input",
      type: "input/text",
    },

    {
      title: "Check Out Date",
      state: "out-date",

      key: "input",
      type: "input/date",
    },

    {
      title: "Check Out Time",
      state: "out-time",
      key: "input",
      type: "input/time",
    },

    {
      title: "Departure Time",
      state: "departure-time",
      key: "input",
      type: "input/time",
    },

    {
      title: "Transport Destination",
      state: "transport-company",
      key: "input",
      type: "input/text",
    },

    {
      title: "Room No",
      state: "room-no",
      key: "input",
      type: "input/number",
    },
    {
      title: "Pickup Point",
      state: "pickup-point",
      key: "input",
      type: "input/text",
    },
    {
      title: "Hotel Time",
      state: "hotel-time",
      key: "hotel_time",
      type: "input/time",
    },
  ],

  Check_Out: [
    {
      title: "BRN no/Cash",
      state: "brn-no",
      key: "brn_select",
      type: "select",
    },

    {
      title: "Actual Hotel",
      state: "actual-Hotel",
      key: "actual_hotel",
      type: "select",
    },

    {
      title: "Hotel Time",
      state: "hotel-time",
      key: "hotel_time",
      type: "input/time",
    },

    {
      title: "Driver Contact Number",
      state: "driver-contact-number",
      key: "input",
      type: "input/number",
    },

    {
      title: "Vehicle Number",
      state: "vehicle-number",
      key: "input",
      type: "input/number",
    },

    {
      title: "Driver Name",
      state: "driver-name",
      key: "input",
      type: "input/text",
    },

    {
      title: "No Of Seats",
      state: "no-of-seats",
      key: "input",
      type: "input/number",
    },

    {
      title: "Check Out Date",
      state: "out-date",
      key: "input",
      type: "input/date",
    },

    {
      title: "Check Out Time",
      state: "out-time",
      key: "input",
      type: "input/time",
    },

    {
      title: "Departure Time",
      state: "departure-time",
      key: "input",
      type: "input/time",
    },

    {
      title: "Transport Destination",
      state: "transport-destination",
      key: "input",
      type: "input/text",
    },

    {
      title: "Room No",
      state: "room-no",
      key: "input",
      type: "input/number",
    },
    {
      title: "Pickup Point",
      state: "pickup-point",
      key: "input",
      type: "input/text",
    },

    {
      title: "Transport Company",
      state: "tranport-company",//change -
      key: "tranport_companies",
      type: "select",
    },
  ],

  CheckIn: [
    {
      title: "BRN no/Cash",
      state: "brn-no",
      key: "brn_select",
      type: "select",
    },
    {
      title: "Package Hotel",
      state: "actual-Hotel",

      key: "package_hotel",
      type: "select",
    },

    // {
    //   title: "Hotel Time",
    //   state: "hotel-time",
    //   key: "hotel_time",
    //   type: "input/time",
    // },

    // {
    //   title: "Transport Company",
    //   state: "transport-company",

    //   key: "transport_company",
    //   type: "select",
    // },

    {
      title: "Room Number",
      state: "room-no",
      key: "input",
      type: "input/number",
    },

    {
      title: "Accomodation",
      state: "accommodation",
      key: "accommodation",
      type: "select",
    },

    {
      title: "Actual No Of Bed (Room)",
      state: "no-of-bed",
      key: "input",
      type: "input/number",
    },
    {
      title: "Actual No Of Bed (Voucher)",
      state: "no-of-bed-voucher",
      key: "input",
      type: "input/number",
    },
    {
      title: "Check In Date",
      state: "in-date",
      key: "input",
      type: "input/date",
    },
    {
      title: "Actual Arrival Time",
      state: "actual-arrival-time",
      key: "input",
      type: "input/time",
    },
    {
      title: "Check Out Date",
      state: "out-date",
      key: "input",
      type: "input/time",
    },
  ],

  AllowTPT: [
    {
      title: "BRN no/Cash",
      state: "brn-no",
      key: "brn_select",
      type: "select",
    },

    {
      title: "Driver Contact Number",
      state: "driver-contact-number",
      key: "input",
      type: "input/number",
    },

    {
      title: "Driver Name",
      state: "driver-name",
      key: "input",
      type: "input/text",
    },

    {
      title: "No Of Seats",
      state: "no-of-seats",
      key: "input",
      type: "input/number",
    },

    {
      title: "Pickup Location",
      state: "pickup-location",
      key: "input",
      type: "input/text",
    },

    {
      title: "Pickup Time",
      state: "pickup-time",
      key: "input",
      type: "input/time",
    },

    {
      title: "Drop off location",
      state: "dropoff-location",
      key: "input",
      type: "input/text",
    },

    {
      title: "Vehicle Number",
      state: "vehicle-number",
      key: "input",
      type: "input/number",
    },

    {
      title: "Transport Company",
      state: "tranport-company",//change -
      key: "tranport_companies",
      type: "select",
    },
    {
      title: "Transport Type",
      state: "tranport-type", //change -
      key: "tranport_types",
      type: "select",
    },
  ],
};
const countrySlice = createSlice({
  name: "Country",
  initialState,
  reducers: {
    setCountry: (state, action) => {
      state.country = action.payload;
    },
    setCountryList: (state, action) => {
      state.listCountry = action.payload;
    },
    setAgent: (state, action) => {
      state.agents = action.payload;
    },
    setCity: (state, action) => {
      state.city = action.payload;
    },
    setHotel: (state, action) => {
      state.hotel = action.payload;
    },
    setArrivalDate_From: (state, action) => {
      state.arrival_data_from = action.payload;
    },
    setArrivalDate_to: (state, action) => {
      state.arrival_date_to = action.payload;
    },
    setCheckinDate: (state, action) => {
      state.check_in_date_from = action.payload;
    },
    setCheckoutDate: (state, action) => {
      state.check_in_date_to = action.payload;
    },
    setCompleted: (state, action) => {
      state.completed = action.payload;
    },
    setLength: (state, action) => {
      state.length = action.payload;
    },
    setTransportList: (state, action) => {
      state.transport = action.payload;
    },
    setTravelType: (state, action) => {
      state.travelType = action.payload;
    },
    setSectors: (state, action) => {
      state.sectors = action.payload;
    },
    setAirports: (state, action) => {
      state.airports = action.payload;
    },
    setPassportDetails: (state, action) => {
      state.passportDetails = action.payload;
    },
    setDashboardData: (state, action) => {

      state.dashboardData = action.payload;
      localStorage.setItem("UserName", JSON.stringify(action.payload.FullName));


    },
    setModalParams: (state, action) => {
      state.modalParams = action.payload;
    },
    setActualTransportData: (state, action) => {
      state.actualTransportData = action.payload;
    },
    clearFilter: (state) => {
      state.country = null;
      state.agents = null;
      state.city = null;
      state.hotel = null;
      state.arrival_data_from = null;
      state.arrival_date_to = null;
      state.check_in_date_from = null;
      state.check_in_date_to = null;
      state.completed = "no";
      state.length = 100;
    },
  },
});
export const {
  setCountry,
  setCountryList,
  setAgent,
  setCity,
  setHotel,
  setArrivalDate_From,
  setArrivalDate_to,
  setCheckinDate,
  setCheckoutDate,
  setCompleted,
  setLength,
  clearFilter,
  setTransportList,
  setTravelType,
  setSectors,
  setAirports,
  setPassportDetails,
  setDashboardData,
  setModalParams,
  setActualTransportData,
} = countrySlice.actions;

export default countrySlice.reducer;
